var map = {
	"./1.png": "dcbc",
	"./2.png": "fcc4",
	"./3.png": "26db",
	"./4.png": "5457",
	"./5.png": "f247",
	"./6.png": "0321",
	"./chanchu.png": "8cc3",
	"./faxing.png": "2c53",
	"./liutong.png": "16a7",
	"./zhiya.png": "a98b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d15";